module.exports = __webpack_public_path__ + "static/media/icon-booth-temptation.404c874e.svg";